import React from 'react';
import { jwtDecode } from 'jwt-decode';

import AMHome from '../Components/TablesForHomePage/AMHome';
import WorkerHome from '../Components/TablesForHomePage/WorkerHome';

import Loading from '../Components/Loading';
import HeadlinePanel from '../Components/HeadlinePanel';

export default function Home() {
  const [userId, setUserId] = React.useState('');
  const [userRole, setUserRole] = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
      setUserRole(decodedToken.role);
    }
  }, []);


  if (!userId || !userRole) {
    return <Loading />;
  }

  return (
    <>
      <div className='mainContainer'>
        <HeadlinePanel label= 'Главная' type='' />
        <div className='containerInner'>
          {userRole === 'Арбитражный управляющий' ? (
            <AMHome userId={userId} />
          ) : (
            <WorkerHome />
          )}
        </div>
      </div>
    </>
  );
};
